//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import ContainerRowReduxTextField from './common/ContainerRowReduxTextField'
import ContainerRowReduxCheckboxField from './common/ContainerRowReduxCheckboxField'
import ContainerRowReduxSelectAndOverrideField from './common/ContainerRowReduxSelectAndOverrideField'
import ContainerRowReduxReadonlyTextAndOverrideField from './common/ContainerRowReduxReadonlyTextAndOverrideField'
import ContainerRowError from '../../components/common/ContainerRowError'
import * as actions from '../../redux/demeter/actions';
import * as actConfDlgActions from '../../redux/actConfDialog/actions';
import type { ReducerState$Type } from '../../redux/demeter/flowTypes';
import type { InvoiceHeaderForm$Props } from './flowTypes'

const refreshTotalAmount=(props:InvoiceHeaderForm$Props)=>{
    const { demeter,isOverrideInvTotal } = props;
    
    if (!isOverrideInvTotal){
        let total = demeter.totalSumOfItemAmount;
        if (total){
            total = parseFloat(total)
            const changeFieldValue = (props.changeFieldValue:any)
            changeFieldValue('invoiceTotal',total.toFixed(2))
        }
    }
}

const renderSubmitButton=(props:InvoiceHeaderForm$Props)=>{
    const { pristine,submitting,isInvalidDoc,invalid } = (props:any);
    const submitOpenActionDialog = (props.submitOpenActionDialog:any)
    const demeter:ReducerState$Type = (props.demeter:any)
    
    if (isInvalidDoc && Object.keys(demeter.formError).length == 0){
        return <button type="button" onClick={()=> submitOpenActionDialog()} className="btn btn-primary btn-lg" disabled={pristine || submitting} >Submit As Invalid Invoice</button>; 
    }else {
        //console.log(demeter.formError)
        if (demeter.demeterItems && demeter.demeterItems.length > 0 && Object.keys(demeter.formError).length == 0) {
            return (
                <div>
                    <button type="button" onClick={()=> submitOpenActionDialog()} 
                    className="btn btn-primary btn-lg" disabled={pristine || submitting} >Submit Your Answer</button>
                </div>    
            )
        }
    }
}

class InvoiceHeaderForm extends React.Component<InvoiceHeaderForm$Props> {
    
    refreshEditData(){
        if (this.props.isVerifyMode){
            const getTaskData = (this.props.getTaskData:any)
            getTaskData(this.props.jwt,this.props.taskAcceptedInfoId)
        }
    }

    componentWillMount(){
        const { jwt,compIdCode,demeter } = this.props;
        if (!demeter.vendorsLoaded){
            const populateVendorsList=(this.props.populateVendorsList:any)
            populateVendorsList(jwt,compIdCode);
        }
        if (!demeter.storeLocationsLoaded){
            const populateStoreLocationsList = (this.props.populateStoreLocationsList:any)
            populateStoreLocationsList(jwt,compIdCode);
        }
    }

    componentDidUpdate(){
        refreshTotalAmount(this.props)
    }

    componentDidMount(){
        this.refreshEditData()
    }

    render(){
        const { pristine,submitting,demeter,
            isInvalidDoc,isOverrideInvTotal,actConfDialog,
            jwt,taskAcceptedInfoId,compIdCode,isOverrideVendorName,isOverrideShipTo
         } = (this.props:any);
        const changeFieldValue = (this.props.changeFieldValue:any)
       
        if (demeter.invoiceSubmitted) {
            return <Redirect to='/projectDemeter/submittedForm' />;
        }

        return (
            <div className='container'>
                <ContainerRowReduxCheckboxField field={'isInvalidDoc'} label={'Invalid Document / Missing Pages / Not load'} />
                
                <ContainerRowReduxSelectAndOverrideField 
                  checkboxField={'isOverrideVendorName'} checkboxLabel={'Override this Vendor Name field'}
                  isOverride={isOverrideVendorName} selectField={'vendorIdCode'} textField={'vendorName'}
                  label={'Vendor Name'} parentProps={this.props} datas={demeter.vendors}
                  selectDataElement={{code: 'vendor_id_code', desc: 'vendor_name'}}
                  changeFieldValue={changeFieldValue}
                />
                
                <ContainerRowReduxSelectAndOverrideField 
                  checkboxField={'isOverrideShipTo'} checkboxLabel={'Override this Ship to Address field'}
                  isOverride={isOverrideShipTo} selectField={'storeIdCode'} textField={'shipToAddr'}
                  label={'Ship To Address'} parentProps={this.props} datas={demeter.storeLocations}
                  selectDataElement={{code: 'store_id_code', desc: 'ship_to'}}
                  changeFieldValue={changeFieldValue}
                />
                
                <ContainerRowReduxTextField field={'invNo'} label={'Invoice Number'} />
                <ContainerRowReduxTextField field={'invDate'} label={'Invoice Date'} />
                <ContainerRowReduxTextField field={'poNo'} label={'PO Number'} />
                <ContainerRowReduxTextField field={'approvalCode'} label={'Approval Code'} />

                <ContainerRowReduxReadonlyTextAndOverrideField 
                    textField={'invoiceTotal'} textLabel={'Total Invoice Amount'} textType={'number'}
                    checkboxField={'isOverrideInvTotal'} checkboxLabel={'Override this Total Invoice Amount field'}
                    isOverride={isOverrideInvTotal} notOverrideFunc={refreshTotalAmount} 
                    parentProps={this.props}
                />
                
                <ContainerRowError errorMsg={demeter.error} />
            
                <div className="row">
                    <div className="col-sm">
                      {renderSubmitButton(this.props)}
                    </div>
                </div>   
            </div>    
        )
    }
}

const mapStateToProps:any = (state, ownProps) => {
    const selector = ownProps.selector

    return {
        vendorIdCode: selector(state, 'vendorIdCode'),
        storeIdCode: selector(state, 'storeIdCode'),
        isOverrideVendorName: selector(state, 'isOverrideVendorName'),
        isOverrideShipTo: selector(state, 'isOverrideShipTo'),
        isInvalidDoc: selector(state, 'isInvalidDoc'),
        isOverrideInvTotal: selector(state, 'isOverrideInvTotal'),
        invoiceTotal: selector(state, 'invoiceTotal')
    }
}

const mapDispatchToProps:any = (dispatch, ownProps) => {
    return {
      populateVendorsList: (jwt,compIdCode) => {
         dispatch(actions.populateVendorsList(jwt,compIdCode))  
      },
      populateStoreLocationsList: (jwt,compIdCode) => {
        dispatch(actions.populateStoreLocationsList(jwt,compIdCode))  
      },
      getTaskData: (jwt:string,taskAcceptedInfoId:number)=>{
        dispatch(actions.getTaskData(ownProps.demeter, jwt, taskAcceptedInfoId))  
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(InvoiceHeaderForm)


// WEBPACK FOOTER //
// ./src/views/ProjectDemeter/InvoiceHeaderForm.js